import "./App.css";
import LandingPage from "./app/components/LandingPage";

function App() {
  return (
    <div className="App">
      <LandingPage />
    </div>
  );
}

export default App;
